import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import PulpoField from '../PulpoField';
import PictureDraggable from '../../../modules/sms/components/PictureDraggable';
import styles from '../../../modules/sms/components/location.module.scss';
import editIcon from '../../../icons/edit.svg';
import Clickable from '../../../components/clickable/Clickable';

const MultiLevelLocation = ({
  locationList,
  info,
  onInfoChange,
  locationKey,
  withoutDepartments,
  subLocationCheckbox,
  withFloorPlan,
  isRequiredTrue,
  showFormErrors,
  handleFieldErrorChanged,
  singleLocation,
  defaultLocation,
  updatedErrors,
  location_marked,
  assetRegistry,
  byDefaultSignleSelect,
  fromSMS,
  fieldName,
  fieldId,
  field
}) => {
  const [openIndoor, setIndoor] = useState(false);
  const [init, setInit] = useState(true);
  const [savedStatus, setSavedStatus] = useState(false);
  const [savedPoint, setSavedPoint] = useState(undefined);
  const [level1_SelectedMap, setLevel1_SelectedMap] = useState('');
  const [locationLevelTitle, setLocationLevelTitle] = useState({});
  let globalLocations = [];
  let selectedMap = '';
  let indoorMap = '';

  useEffect(() => {
    if (info?.location_marked) {
      setSavedPoint(info?.location_marked);
      setSavedStatus(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (locationList && locationList?.length>0) {
      const location_level_title = locationList.find(ele => ele.name === info?.global_location?.location)?.info?.location_level_title;
      setLocationLevelTitle(location_level_title);
    }
  }, [locationLevelTitle, locationList, info]);

  if (withoutDepartments) {
    globalLocations = locationList;
  } else if (locationList && info?.departments && typeof info?.departments === 'object') {
    globalLocations = locationList.filter(loc => (
        loc.departments.filter(dept => (
          info?.departments?.filter(selDep => (selDep?.value?.toString() === dept?.id?.toString()))?.length > 0
        ))?.length > 0
    ));
  } else if (locationList && info?.departments) {
    globalLocations = locationList.filter(loc => (
      loc.departments.filter(dept => (dept?.id?.toString() === info?.departments?.toString()))?.length > 0
    ));
  }
  if (field?.global_location?.name) {
    globalLocations = locationList.filter(loc => (
      loc.name === field?.global_location?.name
    ));
  }

  let levelOneValues = [];
  if (info?.[fieldId]?.level_0) {
    levelOneValues = locationList.filter(
      value => (value?.[locationKey || 'id']?.toString() === info?.[fieldId]?.level_0?.toString())
    );
    if (levelOneValues.length > 0) {
      levelOneValues = levelOneValues[0].location_levels;
      let updatedSelectedmap = '';
      if (info?.[fieldId]?.level_1) {
        updatedSelectedmap = levelOneValues?.find(e => e.title === info?.[fieldId]?.level_1);
      }
      if (updatedSelectedmap?.selected_map && level1_SelectedMap === '') {
        setLevel1_SelectedMap(updatedSelectedmap?.selected_map);
      }
    }
  }
  let levelTwoValues = [];
  if (info?.[fieldId]?.level_0 && info?.[fieldId]?.level_1 && levelOneValues?.length > 0) {
    levelTwoValues = levelOneValues.filter(
      (value) => {
        let checkVal = info?.[fieldId]?.level_1;
        if (value.location_code) {
          checkVal = info?.[fieldId]?.level_1.split(`${value.location_code} - `)[1];
        }
        return value?.title === checkVal;
      }
);
    if (levelTwoValues.length > 0) {
      selectedMap = levelTwoValues[0]?.selected_map;
      indoorMap = levelTwoValues[0]?.attachment;
      levelTwoValues = levelTwoValues[0].level_1;
    }
  }
  let levelThreeValues = [];
  if (info?.[fieldId]?.level_1 && info?.[fieldId]?.level_2 && info?.[fieldId]?.level_0 && levelTwoValues?.length > 0) {
    levelThreeValues = levelTwoValues.filter(
      value => (value?.title === info?.[fieldId]?.level_2)
    );
    if (levelThreeValues.length > 0) {
      if (levelThreeValues[0]?.selected_map === 'airfield' || levelThreeValues[0]?.selected_map === 'indoor') {
        selectedMap = levelThreeValues[0]?.selected_map;
        indoorMap = levelThreeValues[0]?.attachment;
      }
      levelThreeValues = levelThreeValues[0].level_2;
    }
  }

  const handleAttachmentLocation = (locationTitle) => {
    let selectedLoc;
    if (!subLocationCheckbox) {
      selectedLoc = levelOneValues.find(value => value?.title === locationTitle);
      if (selectedLoc) {
          const { selected_map, attachment } = selectedLoc;
          if (selected_map !== '') {
              if (fromSMS && selected_map=== 'indoor') setIndoor(true);
              onInfoChange('location_attachment', attachment?.id, fieldId);
              onInfoChange('selected_map', selected_map, fieldId);
              setLevel1_SelectedMap(selected_map);
          }
      } else {
        onInfoChange('selected_map', undefined, fieldId);
      }
    }
    const l2 = selectedLoc && getLevel(selectedLoc?.level_1);
    const l3 = l2 && getLevel(l2?.level_2);
    onInfoChange('global_location', {
        ...info.fieldId,
        // [fieldName.level_0.title]: locationTitle,
        level_1: locationTitle,
        level_2: l2?.title || '',
        level_3: l3?.title || ''
    }, fieldId);
  };

  const handleAttachmentLocLevel2 = (locationTitle) => {
    let selectedLoc;
    if (!subLocationCheckbox) {
     selectedLoc = levelTwoValues.find(value => value?.title === locationTitle);
      if (selectedLoc) {
          const { selected_map, attachment } = selectedLoc;
          if (selected_map) {
              if (fromSMS && selected_map=== 'indoor') setIndoor(true);
              onInfoChange('location_attachment', attachment?.id, fieldId);
              onInfoChange('selected_map', selected_map, fieldId);
          } else {
            onInfoChange('location_attachment', undefined, fieldId);
              onInfoChange('selected_map', undefined, fieldId);
          }
      } else if (level1_SelectedMap) {
        if (level1_SelectedMap === 'indoor') {
          const attachementData = levelOneValues?.find(e => e?.title === info?.global_location?.location1);
          onInfoChange('location_attachment', attachementData?.attachment?.id, fieldId);
        }
        onInfoChange('selected_map', level1_SelectedMap, fieldId);
      }
    }
    const l3 = selectedLoc && getLevel(selectedLoc?.level_2);
    onInfoChange('global_location', {
        ...info.fieldId,
        level_2: locationTitle,
        level_3: l3?.title || ''
    }, fieldId);
  };

  const getLevel = (levels) => {
    if (!levels) return null;
    const validLevels = levels.filter(item => item.id);
    if (validLevels.length === 1) {
        return validLevels[0];
    }
    if (validLevels.length > 1) {
        return validLevels.find(item => item.default) || null;
    }
    return null;
};

  const handleLocation = (locationTitle) => {
    const location = locationList.find(i => i.name === locationTitle);
    const l1 = getLevel(location?.location_levels);
    const l2 = l1 && getLevel(l1?.level_1);
    const l3 = l2 && getLevel(l2?.level_2);
    if (!locationTitle) {
      onInfoChange('selected_map', undefined, fieldId);
    }
    onInfoChange('global_location',
      { level_0: locationTitle,
        level_1: l1?.title || '',
        level_2: l2?.title || '',
        level_3: l3?.title || ''
      }, fieldId);
  };

  if (((byDefaultSignleSelect && !info?.location) || singleLocation) && init && locationList?.length === 1) {
    handleLocation(locationList?.[0]?.name);
    setInit(false);
  }
  if (field?.global_location?.name && info?.[fieldId]?.level_0===undefined) {
    handleLocation(field?.global_location?.name);
  }
  if (field?.global_location?.default_location_value?.name && info?.[fieldId]?.level_1===undefined) {
    handleAttachmentLocation(field?.global_location?.default_location_value?.name);
  }

  return (
      <>
        {globalLocations?.length > 0 && (
          <>
            <div className={styles.locations}>
              {(byDefaultSignleSelect && locationList?.length === 1) ? '' : (
                <PulpoField
                  type="select"
                  answer={info?.[fieldId]?.level_0}
                  translationID="inspections.step1.locations"
                  title={fieldName?.level_0?.title || 'Locations'}
                  disabled={singleLocation || false}
                  handleValueChange={e => handleLocation(e)}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  values={
                    globalLocations.map(globLoc => (
                      { key: globLoc[locationKey] || globLoc.id, value: globLoc.name }
                    ))
                  }
                  isRequired={isRequiredTrue}
                  showFieldErrors={showFormErrors}
                  className={assetRegistry ? styles.paddingZero : ''}
                />
              )}
              {info?.[fieldId]?.level_0 && levelOneValues?.length > 0 && (
                <PulpoField
                  type="select"
                  answer={info?.[fieldId]?.level_1}
                  translationID="inspections.step1.location1"
                  title={fieldName?.level_1?.title || locationLevelTitle?.location_level_1 || 'Location - Level1'}
                  handleValueChange={e => handleAttachmentLocation(e)}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  updatedErrors={updatedErrors}
                  smslocation1={info?.global_location?.location1}
                  values={levelOneValues
                    .filter(loc => loc.title)
                    .map(loc => ({
                      key: loc.location_code ? `${loc.location_code} - ${loc.title}` : loc.title,
                      value: loc.location_code ? `${loc.location_code} - ${loc.title}` : loc.title
                      }))
                  }
                  isRequired={isRequiredTrue}
                  showFieldErrors={showFormErrors}
                  className={assetRegistry ? styles.paddingZero : ''}

                />
              )}
            </div>
            <div className={styles.locations}>
              {info?.[fieldId]?.level_1 && levelTwoValues?.length > 0 && (
                <PulpoField
                  type="select"
                  answer={info?.[fieldId]?.level_2}
                  translationID="inspections.step1.location2"
                  title={fieldName?.level_2?.title || locationLevelTitle?.location_level_2 || 'Location - Level2'}
                  handleValueChange={e => handleAttachmentLocLevel2(e)}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  values={
                    levelTwoValues.filter(loc => loc.title).map(loc => (
                      { key: loc.title, value: loc.title }
                    ))
                  }
                  className={assetRegistry ? styles.paddingZero : ''}
                />
              )}
              {info?.[fieldId]?.level_2 && levelThreeValues?.length > 0 && (
                <PulpoField
                  type="select"
                  answer={info?.[fieldId]?.level_3}
                  translationID="inspections.step1.location3"
                  title={fieldName?.level_3?.title || locationLevelTitle?.location_level_3 || 'Location - Level3'}
                  handleValueChange={e => onInfoChange(
                    'global_location',
                    {
                      ...info.fieldId,
                      level_3: e
                    }, fieldId
                  )}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  values={
                    levelThreeValues.filter(loc => loc.title).map(loc => (
                      { key: loc.title, value: loc.title }
                    ))
                  }

                />
              )}
            </div>
            {withFloorPlan && (
              <>
                {selectedMap === 'airfield' && (
                  <div className={styles.fullWidth}>
                    <PulpoField
                      key="location"
                      id="location"
                      type="location"
                      translationID="workorder.create.location"
                      title="Location"
                      isRequired={isRequiredTrue}
                      noPolygon
                      handleValueChange={(a, b) => onInfoChange(b, a, fieldId)}
                      answer={info?.[fieldId].location || defaultLocation}
                      showFieldErrors={showFormErrors}
                      handleFieldErrorChanged={handleFieldErrorChanged}
                    />
                  </div>
                )}
                {selectedMap === 'indoor' && (
                fromSMS
                ? <>
                    {info?.[fieldId]?.location_marked?.x > 0 && info?.[fieldId]?.location_marked?.y > 0 && indoorMap
                    ? <div style={{ position: 'relative' }}>
                        <PictureDraggable
                          attachment={indoorMap}
                          position={info?.[fieldId]?.location_marked ?? location_marked}
                          handleSave={() => {
                            setIndoor(false); setSavedStatus(true);
                            setSavedPoint(info?.[fieldId]?.location_marked || location_marked);
                          }}
                          handleSavedStatus={() => setSavedStatus(true)}
                          savedStatus={savedStatus}
                          savedPoint={savedPoint}
                          handleDisplay={() => setIndoor(false)}
                          location={info.fieldId?.location}
                          locDetail
                          fromSMS
                        />
                        <Clickable onClick={() => { setIndoor(true); setSavedStatus(false); }}>
                          <div className={styles.editLocation}>
                            <img src={editIcon} alt="info" width="17px" height="17px" style={{ marginRight: '8px' }} />
                            Edit Location
                          </div>
                        </Clickable>
                      </div>
                    : <>
                        <div className={styles.warning}>
                          No location is selected
                        </div>
                        <div style={{ position: 'relative' }}>
                          <img src={indoorMap?.url} alt={indoorMap?.name || ''} width="736px" height="243px" />
                          <Clickable onClick={() => { setIndoor(true); setSavedStatus(false); }}>
                            <div className={styles.editLocation}>
                              <img src={editIcon} alt="info" width="17px" height="17px" style={{ marginRight: '8px' }} />
                              Edit Location
                            </div>
                          </Clickable>
                        </div>
                      </>
                    }
                  </>
                : <Clickable onClick={() => { setIndoor(true); setSavedStatus(false); }}>
                    <img src={indoorMap?.url} alt={indoorMap?.name || ''} width="736px" height="243px" />
                  </Clickable>
                )}
                {indoorMap && openIndoor && (
                  <div className={styles.fullInput}>
                      <PictureDraggable
                        attachment={indoorMap}
                        position={info?.location_marked ?? location_marked}
                        handleAnswerChanged={(section, value, id) => onInfoChange(id, value, fieldId)}
                        handleSave={() => { setIndoor(false); setSavedStatus(true); setSavedPoint(info?.location_marked || location_marked); }}
                        handleSavedStatus={() => setSavedStatus(true)}
                        savedStatus={savedStatus}
                        savedPoint={savedPoint}
                        handleDisplay={() => setIndoor(false)}
                        location={info.global_location?.location}
                        display={openIndoor}
                        fromSMS={fromSMS}
                      />
                  </div>
                )}
              </>
            )}
            {subLocationCheckbox && (
              <div className={styles.extra}>
                <div className={styles.inlineCheckbox}>
                  <label>
                    <input
                      defaultChecked={info?.all_sublocations}
                      type="checkbox"
                      className={styles.inputStyle}
                      onChange={e => onInfoChange('all_sublocations', e.nativeEvent.target.checked, fieldId)
                      }
                    />
                    <FormattedMessage
                      id="inspection.step1.apply_locs"
                      defaultMessage="Apply to all sub Locations"
                    />
                  </label>
                </div>
              </div>
            )}
          </>
        )}
      </>
  );
};

MultiLevelLocation.propTypes = {
  onInfoChange: PropTypes.func.isRequired,
  info: PropTypes.shape({}).isRequired,
  handleFieldErrorChanged: PropTypes.func,
  isRequiredTrue: PropTypes.shape(Boolean),
  showFormErrors: PropTypes.shape(Boolean)
};

MultiLevelLocation.defaultProps = {
  handleFieldErrorChanged: () => {},
  isRequiredTrue: false,
  showFormErrors: false
};

export default MultiLevelLocation;
